import { useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useTheme } from "styled-components";
import { useStateValue } from "providers";

import {
  Can,
  Chiclet,
  Icon,
  LogoType,
  ThemeChooser,
  Wrapper,
} from "components";
import {
  MenuChiclet,
  Container,
  Header,
  MenuContainer,
  MenuToggle,
  MenuItem,
  MenuOverlay,
  MenuLink,
  MenuSubItem,
  MenuSubLink,
  MenuGroupLabel,
  MenuSection,
  Nav,
} from "./styles";

const Menu = ({ close, show }) => {
  const [
    {
      session: { user },
    },
  ] = useStateValue();
  if (!user?.roles) {
    return (
      <MenuContainer $show={show}>
        <MenuSection>
          <MenuItem>
            <MenuLink to="/login">login</MenuLink>
          </MenuItem>
          <MenuItem>
            <MenuLink to="/signup">sign up</MenuLink>
          </MenuItem>
        </MenuSection>
        <MenuSection>
          <ThemeChooser />
        </MenuSection>
      </MenuContainer>
    );
  }
  return (
    <MenuContainer $show={show}>
      {user.roles?.[0]?.name.indexOf("User") > -1 ||
      user.roles?.[0]?.name.indexOf("Host") > -1 ? (
        <MenuSection>
          <MenuItem>
            <MenuLink to="/">home</MenuLink>
          </MenuItem>
          <MenuItem>
            <MenuLink to="/places">places</MenuLink>
          </MenuItem>
        </MenuSection>
      ) : null}
      {user.roles?.[0]?.name.indexOf("Host") > -1 ? (
        <MenuSection>
          <MenuItem>
            <MenuLink to="/host">My Locations</MenuLink>
          </MenuItem>
          <MenuItem>
            <MenuLink to="/events">events</MenuLink>
          </MenuItem>
        </MenuSection>
      ) : null}
      {user.roles?.[0]?.name === "Admin" ? (
        <MenuSection>
          <Can subject="role" action="read">
            <MenuItem>
              <Wrapper padding="1rem">Admin</Wrapper>
            </MenuItem>
          </Can>
          <Can subject="role" action="read">
            <MenuItem>
              <MenuLink to="/admin/places">places</MenuLink>
            </MenuItem>
          </Can>
          <Can subject="role" action="read">
            <MenuItem>
              <MenuLink to="/admin/roles">roles</MenuLink>
            </MenuItem>
          </Can>
          <Can subject="user" action="read">
            <MenuItem>
              <MenuLink to="/admin/users">users</MenuLink>
            </MenuItem>
          </Can>
          <Can subject="user" action="read">
            <MenuItem>
              <MenuLink to="/admin/beta_signups">beta signups</MenuLink>
            </MenuItem>
          </Can>
          <Can subject="role" action="read">
            <MenuGroupLabel>dungeons</MenuGroupLabel>
            <MenuSubItem>
              <MenuSubLink to="/admin/dungeons">dungeons</MenuSubLink>
            </MenuSubItem>
            <MenuSubItem>
              <MenuSubLink to="/admin/npcs">npcs</MenuSubLink>
            </MenuSubItem>
          </Can>
          <Can subject="role" action="read">
            <MenuItem>
              <MenuLink to="/events">events</MenuLink>
            </MenuItem>
          </Can>
        </MenuSection>
      ) : null}
      <MenuSection>
        <MenuItem>
          <MenuLink to="/messages">messages</MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink to="/account">account</MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink to="/logout">logout</MenuLink>
        </MenuItem>
        <ThemeChooser />
      </MenuSection>
    </MenuContainer>
  );
};

export { Menu, MenuToggle, MenuOverlay };

export const PrimaryLayout = ({ children }) => {
  const [state, setState] = useState();

  const navigate = useNavigate();

  const { colors } = useTheme();

  const goBack = () => {
    navigate(-1);
  };

  const toggleMenu = () => {
    setState(!state);
  };

  return (
    <Container>
      {children}
      <Header>
        <LogoType width="200" />
      </Header>
      <Outlet />
      <Nav onClick={goBack}>
        <Chiclet>
          <Icon icon="chevron-left" fill={colors("foreground")} />
        </Chiclet>
      </Nav>
      <MenuToggle onClick={toggleMenu}>
        <Chiclet>
          <Icon
            icon="menu"
            fill={colors("foreground")}
            stroke={colors("foreground")}
          />
        </Chiclet>
        <Menu show={state} close={() => setState(false)}></Menu>
      </MenuToggle>
      <MenuOverlay $show={state} onClick={() => setState(false)} />
    </Container>
  );
};

export const PageLayout = ({ children, showBackButton = true }) => {
  const [state, setState] = useState();

  const { colors } = useTheme();

  const toggleMenu = () => {
    setState(!state);
  };
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Container>
      {children}
      <Outlet />
      {showBackButton && (
        <Nav onClick={goBack}>
          <Chiclet>
            <Icon icon="chevron-left" fill={colors("foreground")} />
          </Chiclet>
        </Nav>
      )}
      <MenuToggle onClick={toggleMenu}>
        <MenuChiclet>
          <Icon icon="menu" fill={colors("foreground")} />
        </MenuChiclet>
        <Menu show={state} close={() => setState(false)}></Menu>
      </MenuToggle>
      <MenuOverlay $show={state} onClick={() => setState(false)} />
    </Container>
  );
};
